import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface LabelValueRowProps {
  label: string;
  value: ReactNode;
  valueWeight?: 'normal' | 'medium';
}

export function LabelValueRow({
  label,
  value,
  valueWeight = 'normal',
}: LabelValueRowProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography
        variant="body1"
        fontWeight={valueWeight === 'medium' ? 'medium' : undefined}
      >
        {value}
      </Typography>
    </Box>
  );
}
